import React from "react";
import { Helmet } from "react-helmet-async";
import Layout from "../../../components/Layout/layout";
import DonationsPage from "../../../components/Superadmin/donations";
import { HeaderType } from "../../../components/Layout/header";
import ProtectedRoute from "../../../../Auth/components/ProtectedRoute";

const Donations = () => (
  <ProtectedRoute>
    <main>
    <Helmet title="Donations" />
    <Layout headerType={HeaderType.superadmin}>
      <DonationsPage />
    </Layout>
    </main>
  </ProtectedRoute>
);

export default Donations;
